require("../sass/main.scss");
import ReactDOM from "react-dom";
import React from "react";
import { Provider } from "mobx-react";
import ServiceBookingStore from "./components/ServiceBooking/ServiceBookingStore";
import { XTimeServiceBooking } from "./components/ServiceBooking/components";

const providerServiceBooking = (
  <Provider serviceBookingStore={new ServiceBookingStore()}>
    <XTimeServiceBooking />
  </Provider>
);

const serviceRequestRoot = document.getElementById("serviceRequestPage");

if (serviceRequestRoot) {
  ReactDOM.render(providerServiceBooking, serviceRequestRoot);
}
